import styled from 'styled-components'
import { colors } from '@chegg-ui/theme'
import fanta from '@chegg-wt/core/theme/fanta/theme'
import { AspiraStack } from '@chegg-wt/core/theme/fanta/fonts'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${fanta.spacing.fanta.lg} ${fanta.spacing.fanta.md};
  width: 100%;
`

export const Heading = styled.h2`
  color: ${colors.dark};
  ${AspiraStack};
  font-size: 24px;
  font-weight: 900;
  line-height: 1;
  margin: 0 auto ${fanta.spacing.fanta.md};
`

export const Subheading = styled.h3`
  color: ${colors.dark};
  ${AspiraStack};
  font-size: 16px;
  font-weight: 900;
  line-height: 1;
  margin: 0 0 ${fanta.spacing.fanta.xs} 0;
`

export const SourceTypePickerContainer = styled.div`
  margin-left: auto;
  margin-right: auto;
  width: 100%;

  @media (max-width: 900px) {
    max-width: 530px;
  }
`
